export default {"src":"/_next/static/media/brokenWindow_24.28622e6e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};